import Image from "next/image";
import React from "react";

export default function TeamMemberCardImage({ member }) {
  return (
    <figure className="w-full aspect-[1/2] relative">
      <Image
        className="w-full h-[210px] md:h-[350px] rounded-xl max-w-96  object-cover"
        src={process.env.NEXT_PUBLIC_SPACES_URL + member?.image}
        sizes="(max-width:640) 123px,(max-width: 768px) 350px, 560px"
        alt="men"
        // height={50}
        // width={50}
        fill
        loading="lazy"
      />
    </figure>
  );
}
